import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IPaginationItem } from '../../../../types/pagination';

interface IPaginationButtonProps extends IPaginationItem {
  onClick(page: number): void;
}

export function PaginationButton({ onClick, page, disabled, title }: IPaginationButtonProps) {
  return (
    <Button theme="stroke_secondary" disabled={disabled} onClick={() => onClick(page)}>
      {title}
    </Button>
  );
}
